import React from 'react';
import FeedbackForm from './FeedbackForm';
import shape from '../../images/shapes/shape_poligon.svg';
import Bg from '../../images/shapes/shape_2kk_section_bg.svg';
import shape3 from '../../images/shapes/shape_coin.webp';

const FeedbackSection = () => {
    return (
        <section className="feedback_section section_decoration text-center" style={{ fontFamily: 'Palqa', fontSize: 21, backgroundImage: `url(${Bg})` }}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="ico_heading_block" data-aos="fade-up" data-aos-duration="600">
                            <div className="resquare-text mb-4" data-aos="fade-up" data-aos-duration="900">
                                Обратная связь
                            </div>
                        </div>
                        <div className="feedback_form_wrapper" data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
                            <FeedbackForm />
                        </div>
                    </div>
                </div>
            </div>
            <div className="decoration_item shape_shadow_1">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
            <div className="decoration_item shape_shadow_2">
                <img src={shape} alt="Shape Color Shadow" />
            </div>
            <div className="decoration_item shape_coin">
                <img src={shape3} alt="Coin" />
            </div>
        </section>
    );
};

export default FeedbackSection;
